import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import Sidebar from './Sidebar';
import Gallery from './Gallery';
import Category from './Category';
import PhotoGallery from './PhotoGallery';
import AboutUs from './AboutUs';
import Testimonial from './Testimonial';
import Enhanced_category from './enhanced_category';
import Contact_us from './Contact_us';
import CityImage from './CityImage';
import Blog from './blog';
import Subcategory from './subcategory';
import ProjectsCategory from './ProjectsCategory';
import Latest from './latest';
import Completed from './completed';
import Qa from './qa';
import Banner from './banner';
import Recentnews from './recent_news';
import Lowbudgetinetriorad from './lowbudgetinetriorad';

import Affordablecostadmin from './affordablecostadmin';

import PreviousCost from './previouscost';
import Designideada from './designideada';
import ChatReady from './chat_ready';

import BudgetQuery from './budget_query';
 import KitchenCalculator from './kitchen_calculator';
 import KitchenDropdown from './kitchen_dropdown';
 import Referearnadmin from './referearnadmin';
import Kichencalcshow from './kichencalcshow';


const Admin = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  // Admin Table State
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [showmodal, setshowmodal] = useState(false);

  const [adminData, setAdminData] = useState([
    { id: 1, media: "https://via.placeholder.com/60", title: "Modern Sofa Set", category: "Living Room", status: "Active", description: "" },
    { id: 2, media: "https://via.placeholder.com/60", title: "King Size Bed", category: "Bedroom", status: "Active", description: "" },
    { id: 3, media: "https://via.placeholder.com/60", title: "Dining Table Wood", category: "Dining Room", status: "Inactive", description: "" }
  ]);

  const [formData, setFormData] = useState({ id: null, media: "", title: "", category: "", status: "Active", description: "" });

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleOpenModal = (item = null) => {
    if (item) {
      setFormData(item);
    } else {
      setFormData({ id: null, media: "", title: "", category: "", status: "Active", description: "" });
    }
    setshowmodal(true);
  };

  const handleSave = () => {
    if (formData.id) {
      setAdminData(adminData.map(d => (d.id === formData.id ? formData : d)));
    } else {
      setAdminData([...adminData, { ...formData, id: adminData.length ? Math.max(...adminData.map(d => d.id)) + 1 : 1 }]);
    }
    setshowmodal(false);
  };

  const handleDelete = (id) => {
    setAdminData(adminData.filter(d => d.id !== id));
  };

  const stylesD = {
    width: "169%",
    paddingRight: "1102px",
    paddingLeft: "15px",
    marginRight: "auto",
    marginLeft: "auto"
  };

  let role = localStorage.getItem("role");
  if (role) {
    role = role.replace(/['"]/g, '').toLowerCase().trim();
  }


  return (
    <div className="App" style={{ backgroundColor: '#f4f6f9', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <div className="d-flex flex-grow-1 w-100">
        <Sidebar isOpen={sidebarOpen} toggle={() => setSidebarOpen(!sidebarOpen)} />
        <div className="flex-grow-1 d-flex flex-column" style={{ minWidth: 0, maxWidth: '100%' }}>
          
          <div className="d-flex justify-content-between align-items-center bg-white px-4 py-3 shadow-sm">
            <div className="d-flex align-items-center">
              <button 
                className="btn btn-link text-dark p-0 mr-3 d-md-none" 
                onClick={() => setSidebarOpen(!sidebarOpen)} 
                style={{ fontSize: '24px', textDecoration: 'none' }}
              >
                &#8942;
              </button>
              <h4 className="m-0 d-none d-md-block" style={{color:"#a57474"}}>Square & Angle</h4>
            </div>
            
            <div className="d-flex align-items-center">
              <div className="position-relative">
                <div 
                  className="d-flex align-items-center" 
                  style={{ cursor: 'pointer' }} 
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                >
                  <img src="https://via.placeholder.com/40" alt="Profile" className="rounded-circle" style={{ width: '40px', height: '40px' }} />
                </div>
                {dropdownOpen && (
                  <div className="position-absolute bg-white border rounded shadow mt-2" style={{ right: 0, width: '150px', zIndex: 1000 }}>
                    <ul className="list-unstyled m-0 py-2">
                      <li><button className="dropdown-item py-2 border-0 bg-transparent w-100 text-start text-left" style={{ textAlign: 'left' }}>Update Profile</button></li>
                      <li><button className="dropdown-item py-2 border-0 bg-transparent w-100 text-start text-left text-danger" style={{ textAlign: 'left' }}>Logout</button></li>
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </div>

         <div className="bg-white flex-grow-1 overflow-auto p-4 w-100">
            <Routes>
              <Route index element={  
                <div style={isMobile ? {} : stylesD}>
                  <div className="d-flex justify-content-between align-items-center mb-3 w-100">
                    <h5 className="m-0">Admin Data Table</h5>
                    <button className="btn btn-primary" onClick={() => handleOpenModal()}>+ Add New</button>
                  </div>
                  
                  <div className="table-responsive w-100 m-0">
                    <table className="table table-bordered table-hover w-100 m-0">
                      <thead className="thead-dark bg-dark text-white">
                        <tr>
                          <th>Image</th>
                          <th>Title</th>
                          <th>Category</th>
                          <th>Status</th>
                          <th className="text-center">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {adminData.map(item => (
                          <tr key={item.id}>
                            <td>
                              <img src={item.media || "https://via.placeholder.com/60"} alt="img" className="rounded" style={{ width: '50px', height: '50px', objectFit: 'cover' }} />
                            </td>
                            <td>{item.title}</td>
                            <td>{item.category}</td>
                            <td>
                              <span className={`badge p-1 border ${item.status === 'Active' ? 'bg-success text-white border-success' : 'bg-secondary text-white border-secondary'}`}>
                                {item.status}
                              </span>
                            </td>
                            <td className="text-center">
                              <button className="btn btn-sm btn-outline-primary mr-2" style={{ marginRight: '8px' }} onClick={() => handleOpenModal(item)}>Edit</button>
                              <button className="btn btn-sm btn-outline-danger" onClick={() => handleDelete(item.id)}>Delete</button>
                            </td>
                          </tr>
                        ))}
                        {adminData.length === 0 && (
                          <tr>
                            <td colSpan="5" className="text-center">No records found.</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              } />
              
              {role === 'admin' && (
                <>
                
               
               <Route path="gallery" element={<Gallery />} />
              <Route path="category" element={<Category />} />
              <Route path="photo-gallery" element={<PhotoGallery />} />
              <Route path="about-us" element={<AboutUs />} />
              <Route path="testimonial" element={<Testimonial />} />
              <Route path="enhanced_category" element={<Enhanced_category />} />
              <Route path="Contact_us" element={<Contact_us />} />
              <Route path="CityImage" element={<CityImage />} />
              <Route path="blog" element={<Blog />} />
               <Route path="subcategory" element={<Subcategory />} />
               <Route path="ProjectsCategory" element={<ProjectsCategory />} />
               <Route path="completed" element={<Completed />} />
                <Route path="latest" element={<Latest />} />
                <Route path="qa" element={<Qa />} />
               <Route path="banner" element={<Banner />} />
               <Route path="recent_news" element={<Recentnews/>}/>
               <Route path="lowbudgetinetriorad" element={<Lowbudgetinetriorad/>}/>
                <Route path="affordablecostadmin" element={<Affordablecostadmin/>}/>
                <Route path="previouscost" element={<PreviousCost/>}/>
                <Route path="designideada" element={<Designideada />} />
                <Route path="chat_ready" element={<ChatReady />} />
               <Route path="budget_query" element={<BudgetQuery />} />
              <Route path="kitchen_calculator" element={<KitchenCalculator />} />
                <Route path="kitchen_dropdown" element={<KitchenDropdown />} />
                <Route path="referearnadmin" element={<Referearnadmin />} />
                <Route path="kichencalcshow" element={<Kichencalcshow />} />

                </>
              )}
             
            </Routes>
          </div>
        </div>
      </div>
      
      {showmodal && (
        <div className="modal show d-block" style={{ background: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{formData.id ? "Edit Admin Data" : "Add Admin Data"}</h5>
                <button className="close" style={{background: 'transparent', border: 'none', fontSize: '1.5rem'}} onClick={() => setshowmodal(false)}>
                  &times;
                </button>
              </div>
              <div className="modal-body">
                <input type="text"
                  className="form-control mb-2"
                  placeholder="Image URL"
                  value={formData.media}
                  onChange={(e) => setFormData({ ...formData, media: e.target.value })}
                />
                <input type="text"
                  className="form-control mb-2"
                  placeholder="Title"
                  value={formData.title}
                  onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                />
                <input type="text"
                  className="form-control mb-2"
                  placeholder="Category"
                  value={formData.category}
                  onChange={(e) => setFormData({ ...formData, category: e.target.value })}
                />
                <select className="form-control mb-2" value={formData.status} onChange={(e) => setFormData({ ...formData, status: e.target.value })}>
                  <option value="Active">Active</option>
                  <option value="Inactive">Inactive</option>
                </select>
                <textarea
                  className="form-control mb-2"
                  rows="3"
                  placeholder="Description"
                  value={formData.description}
                  onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                />
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setshowmodal(false)}>
                  Close
                </button>
                <button className="btn btn-primary" onClick={handleSave}>
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Admin;